import { useState } from 'react';
import styled from 'styled-components';
import { InputText } from 'ui/inputs';
import { colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const InputWrapper = styled.div`
  > div {
    background: ${colors.purple10};
    border-color: ${colors.purple10};
    color: ${colors.purple70};
    &:hover {
      border: 1px solid ${colors.purple50};
      color: ${colors.purple100};
    }
  }
  &[data-focus='true'] {
    > div {
      background-color: ${colors.white} !important;
    }
    > div > input {
      color: ${colors.textPrimary};
    }
    > div > div > span {
      color: ${colors.textSecondary};
    }
  }
`;
const StyledInput = styled(InputText)`
  && {
    > input {
      background: ${colors.purple10};
      color: ${colors.purple70};
      width: ${pxToRem(30)};
    }
    > input[data-focus='true'] {
      background-color: ${colors.white};
    }
  }
`;

export const PurpleSuffixInput = (props: any) => {
  const [inputHasFocus, setInputHasFocus] = useState(false);
  return (
    <InputWrapper data-focus={inputHasFocus}>
      <StyledInput
        {...props}
        data-focus={inputHasFocus}
        onFocus={() => {
          setInputHasFocus(true);
        }}
        onBlur={() => {
          setInputHasFocus(false);
        }}
      />
    </InputWrapper>
  );
};
